import styled from '@emotion/styled';
import { createElement, FC } from 'react';

type Props = {
  className?: string;
};

const SnapchatDevice169: FC<Props> = (props) => (
  <Root viewBox="0 0 145.783 300.88" {...props}>
    <g data-name="\u30B0\u30EB\u30FC\u30D7 322" transform="translate(-587.796 -157.655)">
      <rect
        data-name="\u9577\u65B9\u5F62 770"
        width={145.783}
        height={300.88}
        rx={21.724}
        transform="translate(587.796 157.655)"
      />
      <g data-name="\u30B0\u30EB\u30FC\u30D7 321">
        <path
          data-name="\u30D1\u30B9 1027"
          d="M726.067 347.111V179.3a14.308 14.308 0 00-14.308-14.308h-14.123v1.918a7.586 7.586 0 01-7.586 7.586h-59.117a7.586 7.586 0 01-7.586-7.586v-1.918h-14.962a14.309 14.309 0 00-14.309 14.308v167.811z"
          fill="#212121"
        />
      </g>
      <path data-name="\u9577\u65B9\u5F62 771" fill="#fff" d="M622.381 192.446h34.371v3.938h-34.371z" />
      <path data-name="\u9577\u65B9\u5F62 772" fill="#fff" d="M622.381 184.516h55.231v4.208h-55.231z" />
      <path
        data-name="\u30D1\u30B9 1028"
        d="M594.076 347.557v89.337a14.309 14.309 0 0014.309 14.306h103.374a14.308 14.308 0 0014.308-14.309v-89.334z"
        fill="#212121"
      />
      <rect
        data-name="\u9577\u65B9\u5F62 773"
        width={34.733}
        height={3.524}
        rx={1.762}
        transform="translate(641.502 443.679)"
        fill="#fff"
      />
      <path data-name="\u9577\u65B9\u5F62 774" fill="#212121" d="M648.385 425.501h23.142v3.938h-23.142z" />
      <circle
        data-name="\u6955\u5186\u5F62 462"
        cx={8.112}
        cy={8.112}
        r={8.112}
        transform="translate(600.927 182.074)"
        fill="#424242"
      />
      <rect
        data-name="\u9577\u65B9\u5F62 775"
        width={128.435}
        height={72.979}
        rx={4.94}
        transform="translate(597.217 206.044)"
        fill="#fffd49"
      />
    </g>
  </Root>
);

const Root = styled('svg')();

export default SnapchatDevice169;
